import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview, sanitizeAnalyticsPath } from '@/lib/analytics';
import { captureAttribution, listenForFormStarts } from '@/lib/attribution';

/**
 * Mounts inside the Router. gtag is loaded statically in index.html; this just
 * reports a page_view on the initial load and every SPA route change. The GA
 * property is at the apex (parcelink.org), so it captures every subdomain.
 *
 * It also records the visit for lead attribution (src/lib/attribution.js) —
 * landing path, outside referrer, campaign tags — which every lead form sends
 * with its post. Stored on the device, not sent anywhere, until a form is.
 */
const Analytics = () => {
  const location = useLocation();

  useEffect(() => { listenForFormStarts(); }, []);

  useEffect(() => {
    captureAttribution(location);
    trackPageview(sanitizeAnalyticsPath(location.pathname, location.search));
  }, [location.pathname, location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default Analytics;
